import { DEFAULT_CTA } from '@lib/constants/summer-camp'
import Button from '@components/atoms/button'
import BookFreeClassBtn from '@components/common/book-free-class-btn'
import TestimonialCard from '@components/summer-camp/testimonial-card'
import {
  TESTIMONIAL,
  ARAB_TESTIMONIAL,
} from '@lib/constants/testimonial-summer-camp'

export const SUMMER_CAMP_IMAGE_PATH = '/images/summer-camp/testimonials/'
export const RAMADAN_CAMP_IMAGE_PATH =
  '/images/ramadan-coding-camp/testimonials/'

type Props = {
  pageCta?: string
  ShouldCtaScrollToTop?: boolean
  isArabCountry?: boolean
}

const Testimonial = ({
  pageCta = DEFAULT_CTA,
  ShouldCtaScrollToTop = true,
  isArabCountry = false,
}: Props) => {
  return (
    <>
      <div
        className="pb-16"
        style={{
          background:
            'linear-gradient(180deg, rgba(236, 240, 253, 0) -0.55%, rgba(255, 247, 245, 0.5) 96.56%)',
        }}
      >
        <div className="px-3 container mx-auto py-10 lg:py-16">
          <h2 className="font-700 text-grey text-3xl lg:text-5xl leading-tight text-center mb-8 lg:mb-16 max-w-3xl mx-auto">
            Here’s why our students{' '}
            <span className="underlined-text">love Codingal</span>
          </h2>
          <div className="px-3 md:px-5 grid grid-cols-1 gap-6 mx-auto lg:grid-cols-2 lg:max-w-6xl lg:px-32">
            {isArabCountry
              ? ARAB_TESTIMONIAL.map((testimonials) => (
                  <TestimonialCard
                    key={testimonials.name}
                    name={testimonials.name}
                    image={`${RAMADAN_CAMP_IMAGE_PATH}${testimonials.image}`}
                    darkText={testimonials.darkText}
                    subHeading={testimonials.subHeading}
                    rating={testimonials.rating}
                    content={testimonials.content}
                  />
                ))
              : TESTIMONIAL.map((testimonials) => (
                  <TestimonialCard
                    key={testimonials.name}
                    name={testimonials.name}
                    image={`${SUMMER_CAMP_IMAGE_PATH}${testimonials.image}`}
                    darkText={testimonials.darkText}
                    subHeading={testimonials.subHeading}
                    rating={testimonials.rating}
                    content={testimonials.content}
                  />
                ))}
          </div>
        </div>
        <div className="flex flex-col w-full px-3 md:px-5">
          <div className="flex flex-col w-full mx-auto space-y-2 lg:flex-row lg:w-auto lg:space-y-0 lg:space-x-4">
            <a
              href="https://www.codingal.com/reviews-and-testimonials/"
              target="_blank"
              rel="noreferrer"
            >
              <Button variant="outline" className="w-full">
                See more reviews
              </Button>
            </a>
            <BookFreeClassBtn
              shouldScrollToTop={ShouldCtaScrollToTop}
              ctaText={pageCta}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Testimonial
